module.exports = __webpack_public_path__ + "img/m1-screenshot-10_t.c30bd193.jpg";